const standFirstTextBlock = {
  key: 'standFirstTextBlock',
  componentKey: 'textblock',
  label: 'Large text'
};

export default standFirstTextBlock;
